import { makeStyles } from '@material-ui/core';
import { Colors } from '../../layout/theme-next';

export default makeStyles({
  link: {
    textDecoration: 'none',
    color: Colors.primary,
    position: 'relative',
  },
});
